import { useState, useCallback } from "react";
import { showMessage } from "react-native-flash-message";
import { useDispatch } from "react-redux";
import { delete_address_action } from "../ducks/user/actions";
import { requestHelper } from "../helpers/request-helper";

export default useDeleteAddress;

function deleteAddressApi({ address_id }) {
  return requestHelper(
    `
        mutation deleteAddress($addressId: Int!) {
          proxyDeleteAddress(addressId: $addressId) {
            suceess
          }
        }
      `,
    {
      addressId: address_id,
    }
  ).then((data) => {
    return data.proxyDeleteAddress;
  });
}

function useDeleteAddress() {
  let [loading, setLoading] = useState(false);
  let dispatch = useDispatch();
  let deleteAddress = useCallback(function delete_memo({ address_id }) {
    setLoading(true);

    return deleteAddressApi({ address_id })
      .then(() => {
        showMessage({
          message: "آدرس با موفقیت حذف شد.",
          type: "success",
        });
        dispatch(
          delete_address_action({
            address_id,
          })
        );
      })
      .catch((e) => {
        showMessage({
          message: "مشکلی در حذف آدرس پیش آمده است.",
          type: "danger",
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return {
    deleteAddress,
    loading,
  };
}
